import { render, staticRenderFns } from "./LogbookReducedFilters.vue?vue&type=template&id=27716043"
import script from "./LogbookReducedFilters.vue?vue&type=script&lang=js"
export * from "./LogbookReducedFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports